module.exports = __webpack_public_path__ + "img/event-conference.8dae7396.png";